import React from 'react'

import OutlineBasket from 'assets/svg/Cesta_outline.svg'
import WhiteBasket from 'assets/svg/Cesta_white.svg'
import GreenBasket from 'assets/svg/Cesta_green.svg'

import ArrowDownWhite from 'assets/svg/arrow_down_white.svg'
import ArrowDownGreen from 'assets/svg/arrow_down_green.svg'

import './CartBadge.scss'

const CartBadge = (props) => {
    const show = props.show ? 'cart-open' : 'cart-close'
    const white = props.show ? 'cart-content white' : 'cart-content'
    return (
        <>
            <div
                id="cartFullContainer"
                className={show}
                onClick={() => props.onClick()}
            />
            <div className={white}>
                <div className="cart" onClick={() => props.onClick()}>
                    <div id="cartBadge" className="cart__badge">
                        {props.badge ? (
                            <span className="badge">{props.badge}</span>
                        ) : null}
                        {props.footer ? (
                            <>
                                <img
                                    className="cart__logo"
                                    width={30}
                                    height={30}
                                    src={OutlineBasket}
                                    alt="Logotipo Alelo"
                                />
                                <span className="cart__description--footer">
                                    Benefícios
                                    <br /> <strong>Selecionados</strong>
                                </span>
                            </>
                        ) : (
                            <>
                                <img
                                    className="cart__logo"
                                    width={30}
                                    height={30}
                                    src={props.show ? WhiteBasket : GreenBasket}
                                    alt="Logotipo Alelo"
                                />
                                <span className="cart__description">
                                    <span>sua cesta de</span>
                                    <br /> <span>proposta</span>
                                    <img
                                        style={{
                                            marginLeft: '8px',
                                            width: '8px',
                                            height: '6px'
                                        }}
                                        src={
                                            props.show
                                                ? ArrowDownWhite
                                                : ArrowDownGreen
                                        }
                                        alt="Arrow Alelo"
                                    />
                                </span>
                            </>
                        )}
                    </div>
                </div>
                {props.children}
            </div>
        </>
    )
}

export default CartBadge
